import { stripSpeakerScriptPlain } from "./speakerMarkdown.js";
/** Count spoken words (markdown/HTML markup excluded). */
export function wordCount(text) {
    const trimmed = stripSpeakerScriptPlain(text);
    if (!trimmed)
        return 0;
    return trimmed.split(/\s+/).filter(Boolean).length;
}
/** Estimate spoken duration in seconds from word count and words-per-minute. */
export function estimateSeconds(text, wpm) {
    const rate = wpm > 0 ? wpm : 140;
    const words = wordCount(text);
    if (words === 0)
        return 0;
    return Math.round((words / rate) * 60);
}
/** Format seconds as m:ss for UI chips. */
export function formatDurationSeconds(totalSeconds) {
    const s = Math.max(0, Math.round(totalSeconds));
    const m = Math.floor(s / 60);
    const rem = s % 60;
    return `${m}:${rem.toString().padStart(2, "0")}`;
}
/** Duration chip color: green in ±10%, amber outside, red >150% of target. */
export function durationChipStatus(estimated, target) {
    if (target <= 0)
        return "ok";
    const ratio = estimated / target;
    if (ratio > 1.5)
        return "over";
    if (ratio < 0.9 || ratio > 1.1)
        return "warn";
    return "ok";
}
